import {observable, flow, makeObservable} from "mobx";
import { EAIClient } from "Services/EAIClient";
import { appStore } from "../";
import {TableauViz} from "@tableau/embedding-api";

export class FilterStore {
    @observable isFilterLoading: boolean;
    @observable isDashboardLoading: boolean;
    @observable viz3: TableauViz | undefined;
    @observable filters: any;
    filterValues: any;

    client = new EAIClient();

    constructor() {
        makeObservable(this);
    }

    resetStore(){
        this.isFilterLoading = true;
        this.isDashboardLoading = false;
        this.viz3 = undefined;
        this.filters = undefined;
        this.filterValues = undefined;
    }

    @flow
    * getFilters(id: number, selectedFilters?: any, filterByValue = false): any{
        this.isFilterLoading = true;
        try {
            const params: any = {};
            if(selectedFilters){
                for(const property in selectedFilters){
                    params[property] = filterByValue ? selectedFilters[property].value : selectedFilters[property].id;
                }
            }
            const resp = yield this.client.getFilters(id, params, filterByValue);
            this.filters = resp.data.data.filters;
            if(resp.data.data.ignored){
                console.error(resp.data.data.ignored);
            }
            this.isFilterLoading = false;
        } catch(e) {
            this.filters = {};
            this.isFilterLoading = false;
            appStore.addError(e);
        }
    }
}